import React from 'react';
import { motion } from 'framer-motion';
import { CreditCardIcon, FileTextIcon, LockIcon, ShoppingCartIcon, StarIcon, TrendingUpIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroTestimonials } from '../data/content';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/76NQmyu4X2DWg45wa3VJBT/Diseno_sin_titulo_(4).png';
const badges = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}, {
  icon: StarIcon,
  label: 'Todos los niveles'
}];
const stats = [{
  value: '+500',
  label: 'atletas confían'
}, {
  value: '6',
  label: 'Tomos listos'
}, {
  value: '6',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}];
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-121" data-mp="3d1ildbzsjgoh">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-122" data-mp="381xmt2oj9aca" data-mpi={index} />)}
    </div>;
}
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink" data-id="element-123" data-mp="3o7c05xxxspgm">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[520px] w-[900px] -translate-x-1/2 rounded-full bg-electric/10 blur-[140px]" aria-hidden="true" data-id="element-124" data-mp="3o5j41cky9nmv" />
      <div className="relative mx-auto max-w-6xl px-5 pb-16 pt-6 text-center sm:px-8 sm:pb-24 sm:pt-12" data-id="element-125" data-mp="3e7l5nw9dmagj">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="text-base font-extrabold uppercase tracking-[0.22em] text-gold sm:text-lg" data-id="element-126" data-mp="30gq1uydqijjt">
          🏋️ Nucleo Fit™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mx-auto mt-4 max-w-4xl text-[2rem] font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl" data-id="element-127" data-mp="2vj7uhcfd8cdx">
          Todo tu sistema de calistenia.
          <span className="mt-1 block text-gold-gradient" data-id="element-128" data-mp="nbl0ygmt488c">Listo. Desde hoy.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.12,
        ease: 'easeOut'
      }} className="relative mx-auto -mt-2 max-w-[280px] sm:mt-2 sm:max-w-md" data-id="element-129" data-mp="iboywmxo6qvf">
          <img src={MOCKUP_URL} alt="Megakit Calistenia Cero Límites: 6 tomos, checklists, planillas y bonos en PDF" className="mx-auto w-full drop-shadow-[0_25px_50px_rgba(46,155,255,0.25)]" width={1024} height={1024} data-id="element-130" data-mp="1ayjhfeaxfg69" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mx-auto -mt-1 max-w-3xl text-lg font-bold leading-snug text-gold sm:mt-2 sm:text-xl" style={{
        fontSize: "16px"
      }} data-id="element-131" data-mp="3lsp1j88sy9bs">
          El sistema N°1 para atletas de calistenia en Argentina para TODOS los niveles
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-neutral-300 sm:text-base" data-id="element-132" data-mp="21bftfk4bp5rt">
          Fundamentos + progresiones + nutrición + programación listos para usar.
        </p>

        <ul className="mx-auto mt-5 flex max-w-3xl flex-nowrap items-center justify-center gap-1.5 sm:gap-2.5" data-id="element-133" data-mp="2b2ahmu14qffw">
          {badges.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-line bg-surface px-2 py-1.5 text-[10px] font-bold text-neutral-200 sm:gap-2 sm:px-4 sm:py-2 sm:text-sm" data-id="element-134" data-mp="2kydryn64xkdx">
              <Icon className="h-3 w-3 shrink-0 text-gold sm:h-4 sm:w-4" aria-hidden="true" data-id="element-135" data-mp="2tx7nsbbn66qf" />
              {label}
            </li>)}
        </ul>

        <div className="mx-auto mt-6 max-w-md" data-id="element-136" data-mp="zndq9dhh3e5d">
          <CtaButton className="py-4 text-base sm:py-5 sm:text-lg" data-id="element-137" data-mp="4acnbfstvv90">
            QUIERO MI MEGAKIT AHORA
          </CtaButton>
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs font-medium text-neutral-500" data-id="element-138" data-mp="3vhfe464r7zip">
            <li className="inline-flex items-center gap-1.5" data-id="element-139" data-mp="9ah3t5tqkpz8">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-140" data-mp="9b0afqdxrrxy" />
              Garantía 7 días
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-141" data-mp="3ho688fg0lw4x">
              <CreditCardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-142" data-mp="3cs8py3l6yfpi" />
              Pago seguro
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-143" data-mp="3rhmzpcsoiz5f">
              <ShoppingCartIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-144" data-mp="3motzn285oezo" />
              Mercado Pago
            </li>
          </ul>
        </div>

        <dl className="mx-auto mt-10 grid max-w-4xl grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-145" data-mp="2yxybqg6tm3xp">
          {stats.map(stat => <div key={stat.label} className="rounded-2xl border border-line bg-surface px-4 py-5" data-id="element-146" data-mp="19inkk74x1129">
              <dt className="sr-only" data-id="element-147" data-mp="1eafbwjvwbatg">{stat.label}</dt>
              <dd data-id="element-148" data-mp="1eb6umu4e9e2b">
                <span className="block text-2xl font-extrabold text-gold sm:text-3xl" data-id="element-149" data-mp="zkzondvkpnii">
                  {stat.value}
                </span>
                <span className="mt-1 block text-xs font-medium text-neutral-400" data-id="element-150" data-mp="14k3vvyyxtb67">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <ul className="mx-auto mt-6 grid max-w-6xl gap-4 text-left lg:grid-cols-3" data-id="element-151" data-mp="1x7pz36496dsj">
          {heroTestimonials.map(item => <li key={item.initials} className="rounded-2xl border border-line bg-surface p-5" data-id="element-152" data-mp="1jat9t93s94dr">
              <div className="flex items-center gap-3" data-id="element-153" data-mp="7t1zk5grgqbx">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gold/15 text-sm font-extrabold text-gold" data-id="element-154" data-mp="7vebo1zu86h2">
                  {item.initials}
                </span>
                <Stars data-id="element-155" data-mp="2ejeqtxryx330" />
              </div>
              <p className="mt-3 text-sm leading-relaxed text-neutral-300" data-id="element-156" data-mp="29i7ju0xng7xe">
                “{item.quote}”
              </p>
              <p className="mt-3 text-xs font-bold text-neutral-500" data-id="element-157" data-mp="24q6aamrv8vb2">
                — {item.name}, {item.location}
              </p>
            </li>)}
        </ul>
      </div>
    </header>;
}